// taskIsOverdue moved to lib/workItems.ts (needs to be reachable from a
// pure, JSX-free module — see that file's header) — re-exported here so
// existing imports of `{ taskIsOverdue } from '../components/StatusBadge'`
// keep working without touching every call site.
export { taskIsOverdue } from '../lib/workItems.ts';

export default function StatusBadge({
  statusName,
  isComplete,
  overdue,
}: {
  statusName: string;
  isComplete: boolean;
  overdue: boolean;
}) {
  if (overdue) return <span className="badge warn">Overdue</span>;
  return <span className={isComplete ? 'badge' : 'badge neutral'}>{statusName}</span>;
}
